import { AbstractControl, FormBuilder } from "@angular/forms";
import { NbPopoverDirective } from "@nebular/theme";
import { QueryList, ViewChildren } from "@angular/core";

// For all components that are used to crteat an entry of a certain data type
import { Component } from '@angular/core';
import dayjs from 'dayjs'
import { allInputDataTypes } from "../interfaces/apiCalls";
import { BaseCreatingEditing } from "./BaseCreatingEditing";
import { ApiService } from "../services/api/api.service";
import { DevicesService } from "../services/devices/devices.service";
import { docType } from "../shared-types/datatypes";
import { TranslateService } from "@ngx-translate/core";


export interface ICreatingComponentInitParams{
    fb: FormBuilder,
    api: ApiService,
    devices: DevicesService
    dataType: docType
}

export class CreatingComponentInitParams {
  fb: FormBuilder;
  api: ApiService;
  devices: DevicesService;
  dataType: docType;
  translate: TranslateService;

  constructor(init: ICreatingComponentInitParams) {
    this.fb = init.fb;
    this.api = init.api;
    this.devices = init.devices;
    this.dataType = init.dataType;
  }
}

@Component({
  template: ''
})
export abstract class CreatingComponent extends BaseCreatingEditing {
    @ViewChildren(NbPopoverDirective) popovers: QueryList<NbPopoverDirective>;

    constructor(init: CreatingComponentInitParams){

      const {fb, api, devices, dataType, translate} = init;
      super({fb, api, devices, dataType, translate});
    }


        // let dayjs decide for now when to use 1900s and 2000s
  // let dayjs decide for now when to use 1900s and 2000s
  setDateToFormcontrol(event, controlName, type : allInputDataTypes) {
    let value = event.target.value
  // Regex pattern to match input a la 11-21-24
    const pattern = /(\d+)[^\d]+(\d+)[^\d]+(\d+)/;

    // Find matches
    const matches = value.match(pattern);

    if (matches) {
      let day = dayjs()
      // Extract numbers
      const firstNumber = matches[1];
      const secondNumber = matches[2];
      const thirdNumber = matches[3];

      let setDay = day.set('date', firstNumber).set('month', secondNumber).set('year', thirdNumber)

        // console.log(`Day: ${setDay.get('date')} Month: ${setDay.get('month')} Year: ${setDay.get('year')}`);
        // console.log("Final day", setDay.toDate())
        // console.log("day valid?", setDay.isValid())
        
        var yearShorterThanBefore = false

        const correctFormField: AbstractControl = this.entryForm.controls[controlName];
        if(!correctFormField['_prevThirdValue']) {
          correctFormField['_prevThirdValue'] = thirdNumber
        } else {
          yearShorterThanBefore = thirdNumber.toString().length < correctFormField['_prevThirdValue'].toString().length
          correctFormField['_prevThirdValue'] = thirdNumber
        }
        if (setDay.isValid()) {

          // console.log("setting value on form !")
          // let correctFormFieldVisible: AbstractControl = this.entryForm.controls[controlName + '-visible'];
          // set what to display in form field
          // set what value to put in form control, but don't emit event to view

     
          // first we set thirdNumber as the final year and then correct it if we autocomplete it further down below.
          var finalYear = thirdNumber

          // do NOT perform auto complete if somebody starts typing 19 or 20, as we can't know if they mean 19.. or 2019, etc.
        if (![19, 20].includes(parseInt(thirdNumber))) {


                // if type is dateBefore, we autocomplete everything past this year to 1900s.
        if (["dateBefore", "dateAny"].includes(type)) {
                // when the type is birthday, we want to auto-complete the year to 1900s, i.e. 25 = 1925, etc, when the entered year is above the two-digit representation of the current year.
                if(thirdNumber.length == 2 && !yearShorterThanBefore && parseInt(thirdNumber) > parseInt(dayjs().year().toString().slice(-2))){
                  event.target.value = `${firstNumber}-${secondNumber}-19${thirdNumber}`
                  finalYear = parseInt(`19${thirdNumber}`)
                  event.target.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
                } else if(thirdNumber.length == 2 && !yearShorterThanBefore && parseInt(thirdNumber) <= parseInt(dayjs().year().toString().slice(-2))) {
                  event.target.value = `${firstNumber}-${secondNumber}-20${thirdNumber}`
                  finalYear = parseInt(`20${thirdNumber}`)
                  event.target.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
                }
              } else if (type == "dateAfter") {
                // when the type is dateAfter, we want to always auto-complete the year to 2000s, i.e. 25 = 2025, etc, 
                if(thirdNumber.length == 2 && !yearShorterThanBefore ){
                  event.target.value = `${firstNumber}-${secondNumber}-20${thirdNumber}`
                  finalYear = parseInt(`20${thirdNumber}`)
                  event.target.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
                } else if(thirdNumber.length == 2 && !yearShorterThanBefore && parseInt(thirdNumber) >= parseInt(dayjs().year().toString().slice(-2))) {
                  event.target.value = `${firstNumber}-${secondNumber}-19${thirdNumber}`
                  finalYear = parseInt(`19${thirdNumber}`)
                  event.target.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
                }
              } 

            let finalDate = day.set('date', firstNumber).set('month', secondNumber - 1 ).set('year', finalYear)
            correctFormField.setValue(finalDate.format('YYYY-MM-DD'))



          // auto-complete the date once two figures are enterted. 24 = 2024, etc. But don't do it when the user is deleting the year.
       /*    if(thirdNumber.length == 2 && !yearShorterThanBefore){
            event.target.value = `${firstNumber}-${secondNumber}-${maybePlus2k}`
            event.target.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
          } */
          // correctFormFieldVisible.setValue(`${firstNumber}-${secondNumber}-${plus2k}`)
          // console.log("Date is valid");
        }
      }
    }
  }

}